import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@vds/buttons";
import { Loader } from "@vds/loaders";
import { Input } from "@vds/inputs";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import NewHeader from "../../layouts/NewHeader";
import { useDispatch } from "react-redux";
import { clearAuthError } from "../../store/actions/auth";
import CircleCheck from "../../assets/circle_check.svg"
import closeIcon from "../../assets/close_icon.svg"
import { fetchForgotPasswordEndPoint } from "../../configuration";

const ForgotPassword = (props) => {
  let navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [emailErrorText, setEmailErrorText] = useState('initial');
  const [loading, setLoading] = useState(true);
  const [left, setLeft] = useState(false);
  const [navmenu, setNavmenu] = useState("hide");
  const [isValid, setIsValid] = useState(null);
  const dispatch = useDispatch();

  useState(() => {
    const savedEmail = localStorage.getItem('user_email');
    setEmail(savedEmail);
    setLoading(false);
    dispatch(clearAuthError());
  }, []);

  const handleEmailChange = (e) => {
    let emailValue = e?.target?.value;
    setEmail(emailValue);
    if (emailValue == '') {
      setEmailError(true);
      setEmailErrorText('Email is required');
    } else if (!validateEmail(emailValue)) {
      setEmailError(true);
      setEmailErrorText('Invalid email format');
    } else {
      setEmailError(false);
      setEmailErrorText('')
    }
  };
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email)
  }

  const resetPassowrd = async (email) => {
    try {
      const response = await fetch(fetchForgotPasswordEndPoint(), {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          email: email,
        })
      });
      
      if (response.ok) {
        setIsValid(true);
      } else {
        setIsValid(false)
      }
    } catch (error) {
      return error;
    }
  };

  const onSubmit = async () => {
    let valid = true;
    if (email === '') {
      setEmailError(true);
      setEmailErrorText('Enter email address');
      valid = false;
    } else if (!validateEmail(email)) {
      setEmailError(true);
      setEmailErrorText('Invalid email address');
      valid = false;
    }
    if (valid) {
      resetPassowrd(email);
      setEmail("");
    }
  };

  return (
    <>
      <NewHeader left={left} setLeft={setLeft} navmenu={navmenu} link={"signin"} />
      <div style={{ height: "calc(94vh - 50px)" }}>
        <Loader active={loading} />
        <br />
        <br />
        <Grid2
          container
          marginTop={1}
          marginBottom={2}
          spacing={1}
          columns={{ xs: 12 }}
          style={{ alignItems: "center" }}
        >
          <Grid2 item xs={3} sm={3} md={3} lg={4} direction="row"></Grid2>
          <Grid2 item xs={12} sm={8} md={6} lg={4} direction="row">
            <div className="login-heading-container">
              <div className="login_heading_forgot_password">
                <h1
                  className="login_heading_h1"
                  align="left"
                >
                  {" "}
                  Forgot Password?
                </h1>

                <div style={{ color: "black", marginTop: "1rem" }} className="invalid_credentials">Enter your email address and an email will be sent with further instructions.</div>

                {isValid == true ?
                  <div className="forgotpassword_success">
                    <div className="success-message">
                      <div className="column icon-column">
                        <img src={CircleCheck} className="icon" alt="circle-check" />
                      </div>
                      <div className="column text-column">
                        <div className="title_forgot_success">Password reset email sent</div>
                        <div className="description_forgot_success">We have sent a password reset link to the email provided. Please check check your mail and follow the instructions provided.</div>
                      </div>
                      <div className="column close-column">
                        <img src={closeIcon} className="close-icon" alt="close-icon" />
                      </div>
                    </div>
                  </div> : ""}
                {isValid == false ?
                  <div className="login_failure">
                    {"The email address doesn't exist."}
                  </div> : ""}
                <div >
                  <label style={{ marginTop: "2rem" }} className="input-label-user">Email</label>
                  <div className="input-container">
                    <input
                      type="text"
                      label="Email address"
                      readOnly={false}
                      className={`form-control login-form-control ${emailError === true ? 'input-invalid-border-background-color' : emailError === false && emailErrorText !== "initial" && email !== "" ? "input-valid-border-background-color" : ""}`}
                      error={emailError}
                      value={email}
                      onChange={handleEmailChange}
                    />
                    {emailError === true ? <i className="bi bi-exclamation-diamond input-icon-failure"></i> : emailError === false && emailErrorText !== "initial" && email !== "" ? <i className="bi-check-lg input-icon-success"></i> : ""}
                  </div>
                  {emailError === true ? <span className="input-label-user">{emailErrorText}</span> : ""}
                </div>
                <Button
                  style={{ marginTop: "2rem" }}
                  type="primary"
                  className="login-pageButton"
                  align={"left"}
                  onClick={onSubmit}
                >
                  Continue
                </Button>
                <Grid2 item xs={12} display="flex" justifyContent="center" style={{ marginTop: "2rem" }}>
                  <span className="below-signin-text">
                    By continuing, you agree to the &nbsp;
                    <a href="/login">Terms & Conditions</a>
                    &nbsp; and<br />
                    <a href="/login">Privacy Policy</a>.
                  </span>
                </Grid2>
              </div>
            </div>

          </Grid2>
        </Grid2>
      </div>
      <div className="row navbar navbar-inverse footerCopyright">
        <div className="col-5">
          <img
            alt={""}
            src="data:image/png;base64,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"
            className="padleft15 img-responseive pull-left"
            style={{ marginLeft: "10px", float: "left" }}
          />
        </div>
        <div className="col-6" style={{ textAlign: "right" }}>
          <span>
            © 2023 Verizon{" "}
          </span>
        </div>
        <div className="col" />
      </div>
    </>
  );
};

export default ForgotPassword;
